import styled from 'styled-components'
import styles from './styles'

const A = styled.a`
  /* stylelint-disable */
  ${styles};
  text-align: center;
`

export default A
